import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { removeItem, setItem } from "utils";

import history from "../services/history";
import Home from "../pages/Home";
import Signup from "../pages/Signup";
import PaymentGroup from "../pages/PaymentGroup";
import TwoFactorOption from "../pages/TwoFactorOption";
import TwoFactorToken from "../pages/TwoFactorToken";
import TwoFactorTokenConfirmation from "../pages/TwoFactorTokenConfirmation";
import File from "../pages/File";

export default function Routes() {
  removeItem("preFilled");

  if (window.location.search) {
    setItem(
      "preFilled",
      Object.fromEntries(new URLSearchParams(window.location.search).entries())
    );
  }

  return (
    <BrowserRouter basename="auth">
      <Switch>
        <Route exact path="/home" component={Home} />
        <Route exact path="/signup/selectGroup" component={PaymentGroup} />
        <Route exact path="/signup/:paymentGroupId" component={Signup} />

        <Route
          exact
          path="/signup/:paymentGroupId/:formStep"
          component={Signup}
        />
        <Route exact path="/:type/signup/:paymentGroupId" component={Signup} />
        <Route
          exact
          path="/:type/signup/:paymentGroupId/:formStep"
          component={Signup}
        />

        <Route
          exact
          path="/:type/plans/:currentUserId/:paymentGroupId"
          component={Signup}
        />
        <Route
          exact
          path="/:type/plans/:currentUserId/:paymentGroupId/:formStep"
          component={Signup}
        />

        <Route
          exact
          path="/plans/:currentUserId/:paymentGroupId/:formStep"
          component={Signup}
        />
        <Route
          exact
          path="/plans/:currentUserId/:paymentGroupId"
          component={Signup}
        />

        <Route exact path="/file/:dns/:type" component={File} />
      </Switch>
    </BrowserRouter>
  );
}
